module.exports = __webpack_public_path__ + "static/media/xanhNhat.13f59c50.png";